import { render, staticRenderFns } from "./AppDepartmentContactsBlock.vue?vue&type=template&id=318b7f86"
import script from "./AppDepartmentContactsBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentContactsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports